import React, { useState } from "react";
import Layout from "../../Layout";
import "./project_case.css";

import Portfolio_Banner from "../../Images/Portfolio_Banner.png";

export default function MyPortfolio() {
  const [active, setActive] = useState("discover");

  function showDiscover() {
    setActive("discover");
  }
  function showWireframes() {
    setActive("wireframes");
  }
  function showDev() {
    setActive("dev");
  }
  function showFinal() {
    setActive("final");
  }

  return (
    <Layout>
      <main className="cs-page">
        {/* 1) FULL WIDTH HERO IMAGE */}
        <section className="cs-hero">
          <img src={Portfolio_Banner} alt="My Portfolio Banner" />
        </section>

        {/* 2) TITLE / TAGLINE / META */}
        <section className="cs-block">
          <h1 className="cs-title">
            {" "}
            <u>My Portfolio!</u>
          </h1>
          <p className="cs-tagline">
             A personal portfolio designed to showcase my technical projects, UI/UX work, and creative identity in one website.
          </p>

          <div className="cs-divider" />

          <div className="cs-meta">
            <div className="cs-meta-item">
              <h3 className="cs-meta-label">Timeline</h3>
              <p className="cs-meta-text">June 2025 – November 2025</p>
            </div>
            <div className="cs-meta-item">
              <h3 className="cs-meta-label">Programs Used</h3>
              <p className="cs-meta-text">
                {" "}
                Procreate, Adobe Photoshop + Illustrator, Figma, Javascript,
                React.JS, HTML/CSS, Git + GitHub
              </p>
            </div>
          </div>
          <div className="cs-divider" />
        </section>

        {/* 3) ABOUT THE PROJECT */}
        <section className="cs-block">
          <h2 className="cs-h2">About the Project</h2>
          <p className="cs-tagline">
            This portfolio was built to bring together my technical projects,
            UI/UX design, and art work into a single website. I wanted a space
            that felt personal, modern, and expressive — while still maintaining
            clarity, structure, and a clean user experience. Every page is
            designed to highlight my technical strengths, my design philosophy,
            the projects that shaped my development journey, and a sprinkle of
            my personality into every page.
          </p>
        </section>

        <div className="cs-divider" />

        {/* 4) MY ROLE + ACCOMPLISHMENTS */}
        <section className="cs-block">
          <h2 className="cs-h2">My Role</h2>
          <p className="cs-tagline">
            I designed, developed, and refined the entire portfolio from scratch
            using React. My role included UI/UX design, custom animations,
            responsive layouts, accessibility considerations, and organizing
            content that reflects both technical skill and personality.
          </p>

          <div className="cs-card">
            <div class="cs-item">
              <span class="cs-item-title">UI/UX Design: </span>
              <span class="cs-item-text">
                Designed the full site layout in Figma, defining hierarchy,
                spacing, and structure for each page.
              </span>
            </div>

            <div class="cs-item">
              <span class="cs-item-title">
                Responsive Front-End Development:
              </span>
              <span class="cs-item-text">
                Built the portfolio using React and custom CSS, ensuring that
                every section scales smoothly across desktop, tablet, and
                mobile.
              </span>
            </div>

            <div class="cs-item">
              <span class="cs-item-title">Brand Identity Creation: </span>
              <span class="cs-item-text">
                Developed a cohesive visual style through color palettes,
                typography, custom graphics, and iconography created in
                Procreate and Adobe tools.
              </span>
            </div>

            <div class="cs-item">
              <span class="cs-item-title">Content Architecture: </span>
              <span class="cs-item-text">
                Organized all project pages, descriptions, and case studies to
                balance storytelling with technical clarity.
              </span>
            </div>

            <div class="cs-item">
              <span class="cs-item-title">Version Control & Deployment: </span>
              <span class="cs-item-text">
                Maintained the project using Git/GitHub and structured it for
                easy updates as my work grows.
              </span>
            </div>
          </div>
        </section>

        <div className="cs-divider" />

        {/* 6) MY PROCESS: MENU (left) + PANEL (right) */}
        <section className="cs-block">
          <h2 className="cs-h2">My Process</h2>

          <div className="cs-process">
            <div className="cs-menu">
              <button
                className={
                  "cs-menu-item" + (active === "discover" ? " is-active" : "")
                }
                onMouseEnter={showDiscover}
              >
                Vision
              </button>

              <button
                className={
                  "cs-menu-item" + (active === "wireframes" ? " is-active" : "")
                }
                onMouseEnter={showWireframes}
              >
                Design
              </button>

              <button
                className={
                  "cs-menu-item" + (active === "dev" ? " is-active" : "")
                }
                onMouseEnter={showDev}
              >
                Implementation
              </button>

              <button
                className={
                  "cs-menu-item" + (active === "final" ? " is-active" : "")
                }
                onMouseEnter={showFinal}
              >
                Launch
              </button>
            </div>

            <div className="cs-panel">
              {/* VISION */}
              <div
                className="cs-pane"
                style={{ display: active === "discover" ? "block" : "none" }}
              >
                <h3 className="cs-pane-title">
                  <u>Vision</u>
                </h3>
                <p className="cs-tagline">
                  I began this portfolio with a clear goal: create a space that
                  reflects my growth as a developer, designer, and leader. I
                  wanted the site to feel personal, intentional, and easy to
                  navigate—something that communicates my personality while
                  staying professional and readable to recruiters, hiring
                  managers, and collaborators.
                </p>

                <p className="cs-tagline">
                  To shape the direction of the project, I listed out everything
                  a user might want to see: my story, my technical work, my
                  UI/UX process, and my art. From there, I defined the structure
                  of each case study and how they should flow together. This
                  phase set the foundation for a cohesive, thoughtful
                  experience.
                </p>
              </div>

              {/* DESIGN */}
              <div
                className="cs-pane"
                style={{ display: active === "wireframes" ? "block" : "none" }}
              >
                <h3 className="cs-pane-title">
                  <u>Design</u>
                </h3>
                <p className="cs-tagline">
                  I moved into Figma to map out page layouts, spacing, and
                  visual hierarchy. My focus was clarity—clean sections,
                  readable typography, strong dividers, and a warm aesthetic
                  that reflects my style. I sketched multiple layouts, explored
                  color palettes, and experimented with different ways to
                  present my projects.
                </p>

                <p className="cs-tagline">
                  After settling on a direction, I refined the wireframes into
                  reusable UI patterns that could scale with more projects. Each
                  design choice was made to balance beauty and usability,
                  ensuring the site feels polished on desktop, tablet, and
                  mobile.
                </p>
              </div>

              {/* IMPLEMENTATION */}
              <div
                className="cs-pane"
                style={{ display: active === "dev" ? "block" : "none" }}
              >
                <h3 className="cs-pane-title">
                  <u>Implementation</u>
                </h3>
                <p className="cs-tagline">
                  I built the site using React and custom CSS, structuring each
                  section into components that could be reused across the
                  portfolio. I focused on accessibility, responsiveness, and
                  performance while keeping the code clean and easy to maintain.
                </p>

                <p className="cs-tagline">
                  Each project page was built like a case study—complete with
                  timelines, goals, roles, and process panels. I also wrote
                  custom hover states, animations, and layout logic to make the
                  experience smooth and engaging across devices. The
                  implementation phase brought the UI to life exactly how it
                  looked in the designs.
                </p>
              </div>

              {/* LAUNCH */}
              <div
                className="cs-pane"
                style={{ display: active === "final" ? "block" : "none" }}
              >
                <h3 className="cs-pane-title">
                  <u>Launch</u>
                </h3>
                <p className="cs-tagline">
                  The final phase focused on refinement—polishing spacing,
                  improving text flow, reorganizing sections, fixing mobile
                  issues, and optimizing color and contrast. I also wrote clear
                  descriptions for each project, ensuring the storytelling
                  stayed consistent throughout the site.
                </p>

                <p className="cs-tagline">
                  After final testing across screen sizes, I deployed the
                  portfolio and reviewed everything as if I were a first-time
                  visitor. The end result is a personal, interactive space that
                  reflects not just what I’ve built, but who I am as a designer,
                  developer, and creative.
                </p>
              </div>
            </div>
          </div>
        </section>

        <div className="cs-divider" />

        {/* 7) Learning & Impact */}
        <section className="cs-block">
          <h2 className="cs-h2">Learning & Impact</h2>
          <p className="cs-tagline">
            Building this portfolio taught me how to blend engineering with
            storytelling. I strengthened my ability to design intentionally,
            code responsively, and present complex projects in a way that is
            easy and enjoyable to explore.
          </p>

          <div className="cs-card">
            <div class="cs-item">
              <span class="cs-item-title">Design Systems Thinking:</span>
              <span class="cs-item-text">
                Learned how to maintain a unified design language across
                multiple pages, sections, and components.
              </span>
            </div>

            <div class="cs-item">
              <span class="cs-item-title">Responsive Architecture:</span>
              <span class="cs-item-text">
                Gained deeper experience building scalable layouts that adapt
                fluidly across devices without breaking structure.
              </span>
            </div>

            <div class="cs-item">
              <span class="cs-item-title">Content Strategy:</span>
              <span class="cs-item-text">
                Developed skill in writing clear, professional, and compelling
                project descriptions tailored to both technical and
                non-technical audiences.
              </span>
            </div>

            <div class="cs-item">
              <span class="cs-item-title">Component Reusability:</span>
              <span class="cs-item-text">
                Strengthened my ability to build modular, reusable React
                components for faster development and better maintainability.
              </span>
            </div>

            <div class="cs-item">
              <span class="cs-item-title">Personal Branding:</span>
              <span class="cs-item-text">
                Learned how to translate personality into a digital experience
                through visuals, writing, and interaction design.
              </span>
            </div>
          </div>
        </section>
      </main>
    </Layout>
  );
}
